import { RouteRecordRaw } from "vue-router";

export const penaltyTypeRoutes: Array<RouteRecordRaw> = [
  {
    path: "/penalty-types/:id/edit",
    name: "PenaltyTypeEdit",
    component: () => import("../views/PenaltyTypeEdit.vue"),
    meta: {
      requiresAuth: true,
      requiredModule: "penaltyType",
      requiredRight: "viewUI",
    },
  },
];
